import axios from "axios";
import { Urls } from "../../../store/urls";

export const getRegisterDegreeGroupingRepo = (params) => {
    return axios({
        method: "GET",
        url: Urls.GET_CMS_DEGREE_GROUPINNG,
        params: params,
    });
};

export const postRegisterDegreeGroupingRepo = (data) => {
    return axios({
        method: "POST",
        url: Urls.POST_CMS_DEGREE_GROUPING,
        data: data,
    });
};
